// extracted by mini-css-extract-plugin
export default {"root":"DI0S4","noInviteIcon":"GPG6n","noInvite":"aBUx8"};